export function orderAlphabetically(arrayIn, type, property) {

    if (type === '' || property === '') {
        return arrayIn;
    }

    if (property === 'weight') {
        let weightAverage = 'weightAverage';
        const arrayOut = arrayIn.map(obj => {
            let arrayOfString = obj[property].split(' ');
            let arrayOfNumbers = [Number(arrayOfString[0]), Number(arrayOfString[2])]
            let propertyNum = (arrayOfNumbers[0] + arrayOfNumbers[1]) / 2;
            return {
                ...obj,
                [weightAverage]: propertyNum
            }
        })

        if (type === 'asc') {
            function ascOrder(x, y) {
                if (x[weightAverage] < y[weightAverage]) { return -1; }
                if (x[weightAverage] > y[weightAverage]) { return 1; }
                return 0;
            }
            return arrayOut.sort(ascOrder);
        }

        if (type === 'des') {
            function desOrder(x, y) {
                if (x[weightAverage] < y[weightAverage]) { return 1; }
                if (x[weightAverage] > y[weightAverage]) { return -1; }
                return 0;
            }
            return arrayOut.sort(desOrder);
        }
    }

    if (property === 'name') {
        if (type === 'asc') {
            function ascOrder(x, y) {
                if ((x[property].toLowerCase()) < y[property].toLowerCase()) { return -1; }
                if (x[property].toLowerCase() > y[property].toLowerCase()) { return 1; }
                return 0;
            }
            return arrayIn.sort(ascOrder);
        }

        if (type === 'des') {
            function desOrder(x, y) {
                if (x[property].toLowerCase() < y[property].toLowerCase()) { return 1; }
                if (x[property].toLowerCase() > y[property].toLowerCase()) { return -1; }
                return 0;
            }
            return arrayIn.sort(desOrder);
        }
    }
}



export function createPages(arrayLength, pageSize) {
    let length = arrayLength;
    let numberPages = 0;
    let pages = {}

    if (length % pageSize === 0) {
        numberPages = length / pageSize;
        for (let i = 1; i <= numberPages; i++) {
            let max = (pageSize * i);
            let min = max - pageSize;

            pages[i] = [min, max]
        }
        return pages;
    }
    if (length % pageSize !== 0) {
        numberPages = Math.floor(length / pageSize);
        for (let i = 1; i <= numberPages; i++) {
            let max = (pageSize * i);
            let min = max - pageSize;

            pages[i] = [min, max]
        }
        pages[numberPages + 1] = [numberPages * pageSize, length]
        return pages;
    }
}